export enum LoyaltyLevels {
  Blue = 'blue',
  Bronze = 'bronze',
  Silver = 'silver',
  Gold = 'gold',
  Gold50 = 'gold50',
  None = '',
}
